export default __webpack_public_path__ + "static/media/259.4d95b335.gif";